// De keuzes in de dialoog Start project. De server zegt per bestand wat bij de
// gekozen percelen hoort (`preselected`); wat de gebruiker zelf aan- of uitvinkt
// wint, ook als een nieuwe perceelkeuze een nieuwe preview oplevert.

export interface PreviewFile {
  id: number;
  name: string;
  category: string;
  preselected: boolean;
}

// Volgorde van de mappen zoals in Bestanden: eerst de losse bestanden.
const CATEGORY_ORDER = [
  "",
  "basisgegevens",
  "ontwikkeling",
  "omgeving",
  "bodem",
  "natuur",
  "onderzoek",
];

export const isChecked = (file: PreviewFile, manual: Record<number, boolean>) =>
  manual[file.id] ?? file.preselected;

export const checkedFileIds = (preview: PreviewFile[], manual: Record<number, boolean>) =>
  preview.filter((file) => isChecked(file, manual)).map((file) => file.id);

export const filesByCategory = (preview: PreviewFile[]): [string, PreviewFile[]][] => {
  const groups = new Map<string, PreviewFile[]>();
  for (const file of preview) {
    groups.set(file.category, [...(groups.get(file.category) ?? []), file]);
  }
  const rank = (category: string) => {
    const index = CATEGORY_ORDER.indexOf(category);
    return index === -1 ? CATEGORY_ORDER.length : index;
  };
  return [...groups.entries()].sort(([a], [b]) => rank(a) - rank(b));
};
